import { useState } from "react";
import { MouseIcon } from "frontend/icons/mouse";
import { TrackpadIcon } from "frontend/icons/trackpad";
import { NavMode } from "state-atoms/nav-atoms";
import styles from "./device-selection-step.module.css";
import OnboardingPanel from "frontend/canvas-onboarding/shared/onboarding-panel/onboarding-panel";
import tracking from "frontend/tracking";

interface DeviceSelectionStepProps {
  onSelect: (device: NavMode) => void;
  onDismiss: () => void;
}

export default function DeviceSelectionStep({ onSelect, onDismiss }: DeviceSelectionStepProps) {
  const [navMode, setNavMode] = useState<NavMode>("trackpad");

  return (
    <OnboardingPanel
      name="onboarding_cim_device_selection"
      title="What are you using right now?"
      description={"Choose your setup, and we’ll tailor\nWorkCanvas to match"}
      ctaText="Apply"
      onCtaClick={() => onSelect(navMode)}
      onClose={onDismiss}
    >
      <div className={styles.optionsContainer}>
        <div
          className={`${styles.option} ${navMode === "trackpad" ? styles.selected : ""}`}
          onClick={() => {
            setNavMode("trackpad");
            tracking.trackAnalyticsEvent(`onboarding_cim_device_selection_trackpad_selected`);
          }}
        >
          <div className={styles.iconWrapper}>
            <TrackpadIcon />
          </div>
          <div className={styles.radioWrapper}>
            <div className={styles.radioButton}>{navMode === "trackpad" && <div className={styles.radioInner} />}</div>
            <span className={styles.optionLabel}>Trackpad</span>
          </div>
        </div>

        <div
          className={`${styles.option} ${navMode === "mouse" ? styles.selected : ""}`}
          onClick={() => {
            setNavMode("mouse");
            tracking.trackAnalyticsEvent(`onboarding_cim_device_selection_mouse_selected`);
          }}
        >
          <div className={styles.iconWrapper}>
            <MouseIcon />
          </div>
          <div className={styles.radioWrapper}>
            <div className={styles.radioButton}>{navMode === "mouse" && <div className={styles.radioInner} />}</div>
            <span className={styles.optionLabel}>Mouse</span>
          </div>
        </div>
      </div>
    </OnboardingPanel>
  );
}
